/* Shared by the product template and the hosted studio review. */
(() => {
  for (const root of document.querySelectorAll('[data-lig-wrist]')) {
    const input = root.querySelector('[data-name]');
    const count = root.querySelector('[data-count]');
    const message = root.querySelector('[data-message]');
    const image = root.querySelector('[data-lettering]');
    const details = root.querySelector('[data-fit]');
    const button = root.querySelector('[data-submit]');
    const form = root.querySelector('form');
    const variant = root.querySelector('[data-variant-select]');
    const card = root.querySelector('[data-name-card]');
    const mode = () => variant?.selectedOptions[0]?.dataset.embroidery || 'personalized';
    let sequence = 0, timer, valid = '', busy = false;
    const endpoint = root.dataset.endpoint || 'https://lig-fulfillment-middleware.vercel.app/api/wrist-embroidery';
    const characters = name => [...new Intl.Segmenter('en', { granularity: 'grapheme' }).segment(name)].length;
    function note(text, error = false) {
      message.textContent = text;
      message.dataset.error = String(error);
    }
    async function preview() {
      const mine = ++sequence;
      valid = ''; button.disabled = true;
      const value = input.value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleUpperCase('en-US').normalize('NFC');
      const length = characters(value);
      count.textContent = `${length} / 12`;
      image.hidden = true; details.textContent = '';
      input.setCustomValidity('');
      if (mode() === 'chest_only') { button.disabled = busy || !!variant?.selectedOptions[0]?.disabled; return true; }
      if (!value) { note('Enter a name to see the lettering.'); return false; }
      if (length > 12) {
        const error = 'Use 12 characters or fewer, including spaces. Choose a nickname; we won’t shorten it for you.';
        input.setCustomValidity(error); note(error, true); return false;
      }
      note('Checking the lettering…');
      try {
        const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name: value }) });
        const result = await response.json();
        if (mine !== sequence || mode() === 'chest_only') return false;
        if (!response.ok) throw new Error(result.error || 'Please try the name again.');
        valid = result.name;
        image.src = result.preview;
        image.width = Math.round(result.lengthInches * 300);
        image.height = Math.round(result.lettersHeightInches * 300);
        image.alt = `Lettering for ${result.name}`;
        image.style.width = `${Math.round(result.lengthInches / (result.maxWidthInches || 1.85) * 100)}%`;
        image.hidden = false;
        details.textContent = `${result.lettersHeightInches.toFixed(2)}″ letter height · ${result.lengthInches.toFixed(2)}″ name length`;
        note(`Your wrist will read ${result.name}. Please check the spelling.`);
        button.disabled = false;
        return true;
      } catch (error) {
        if (mine !== sequence || mode() === 'chest_only') return false;
        const text = error.message || 'The preview is unavailable. Please try again.';
        input.setCustomValidity(text); note(text, true); return false;
      }
    }
    function syncMode() {
      clearTimeout(timer); ++sequence; valid = ''; input.setCustomValidity('');
      const plain = mode() === 'chest_only';
      input.disabled = plain; input.required = !plain;
      if (card) card.hidden = plain;
      image.hidden = true;
      button.disabled = busy || !plain || !!variant?.selectedOptions[0]?.disabled;
      if (!plain && input.value && !busy) preview();
      else note(plain ? 'Golden chest embroidery included. Your cuff will be unembroidered.' : 'Enter a name to see the lettering.');
    }
    variant?.addEventListener('change', syncMode);
    input.addEventListener('input', () => {
      clearTimeout(timer); ++sequence; valid = ''; button.disabled = true;
      input.setCustomValidity(''); image.hidden = true; details.textContent = '';
      note('Checking the lettering…');
      const value = input.value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleUpperCase('en-US');
      count.textContent = `${characters(value)} / 12`;
      timer = setTimeout(preview, 400);
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      clearTimeout(timer);
      busy = true;
      const selectedId = variant?.value, selectedMode = mode();
      const checked = await preview();
      if (variant?.value !== selectedId || mode() !== selectedMode) { busy = false; syncMode(); return; }
      if (!checked) { busy = false; if (!input.disabled) input.reportValidity(); return; }
      if (variant?.selectedOptions[0]?.disabled) { busy = false; syncMode(); return; }
      if (root.dataset.review === 'true') { busy = false; note(`${valid} is ready for your design review.`); return; }
      if (selectedMode === 'personalized') input.value = valid;
      button.disabled = true;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const added = await response.json();
        if (!response.ok) throw new Error(added.description || 'This garment could not be added. Please try again.');
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (error) { busy = false; button.disabled = false; note(error.message, true); }
    });
    syncMode();
  }
})();
